import { combineReducers } from 'redux';
import articles from './reducers/articles';

export default combineReducers({
    articles
});